export default "__VITE_ASSET__04b005de__"